"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _designTokens = require("@decisiv/design-tokens");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}
/**
 * This is a modified version of the Normalize CSS setup, but with
 * the `html` and `body` bits removed (since we intend to only apply
 * this normalizer to the CSS-scoped tree containing KeyDS components),
 * and any element-specific styles extracted to the KeyDS components
 * built on top of those elements.
 *
 * Styles for elements and selectors that are not (yet) reflected in
 * KeyDS components remain here.
 */


var normalize = (0, _styledComponents.css)(["line-height:1.15;-webkit-text-size-adjust:100%;b,strong{font-weight:", ";}kbd,samp{font-family:", ";font-size:1em;}small{font-size:80%;}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline;}sub{bottom:-0.25em;}sup{top:-0.5em;}img{border-style:none;}[type='number']::-webkit-inner-spin-button,[type='number']::-webkit-outer-spin-button{height:auto;}[type='search']{-webkit-appearance:textfield;outline-offset:-2px;}[type='search']::-webkit-search-decoration{-webkit-appearance:none;}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit;}[hidden]{display:none;}"], _designTokens.typography.weight.alias.extrabold, _designTokens.typography.typeface.mono);
/**
 * A limited CSS reset based on Elad Schechter's article here:
 * https://medium.com/@elad/normalize-css-or-css-reset-9d75175c5d1e
 */

var cssReset = (0, _styledComponents.css)(["*,*::before,*::after{box-sizing:border-box;}"]);
/**
 * Basic typography styling that should be applied globally.
 */

var typographyBase = (0, _styledComponents.css)(["font-family:", ";font-size:", ";font-weight:", ";color:", ";letter-spacing:normal;font-feature-settings:normal;font-variant-numeric:normal;"], _designTokens.typography.typeface.default, (0, _rem.default)(_designTokens.typography.size.alias.default), _designTokens.typography.weight.alias.default, (0, _toColorString.default)(_designTokens.color.base.charcoal));

var Normalizer = _styledComponents.default.div.withConfig({
  displayName: "normalizer__Normalizer",
  componentId: "hi5hos-0"
})(["", ";", ";", ";"], normalize, cssReset, typographyBase);

var _default = Normalizer;
exports.default = _default;